var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgWhatsappSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 014-4h16a4 4 0 014 4v16a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
    fill: "#25D366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.958 3.01a8.421 8.421 0 015.565 2.46A8.353 8.353 0 0121 11.43c-.002 4.645-3.8 8.424-8.464 8.424h-.004a8.49 8.49 0 01-4.045-1.025L4 20l1.2-4.365a8.378 8.378 0 01-1.129-4.212C4.073 6.78 7.87 3 12.536 3l.422.01zM8.695 17.304l.257.151a7.05 7.05 0 003.58.976h.004c3.877 0 7.033-3.14 7.035-7.001 0-1.871-.73-3.63-2.059-4.954a7.004 7.004 0 00-4.974-2.053c-3.88 0-7.036 3.14-7.038 7a6.96 6.96 0 001.076 3.727l.167.265-.71 2.584 2.662-.695zm8.105-3.87c-.053-.089-.194-.141-.405-.247-.212-.105-1.252-.614-1.446-.684-.194-.07-.335-.106-.476.105-.14.21-.546.685-.67.825-.123.14-.246.158-.457.053-.212-.105-.893-.328-1.701-1.045-.629-.558-1.053-1.247-1.177-1.458-.123-.21-.013-.325.093-.43.095-.094.212-.245.317-.368.106-.123.141-.211.212-.351.07-.14.035-.264-.018-.37-.053-.105-.476-1.14-.652-1.562-.172-.41-.346-.355-.476-.361a8.56 8.56 0 00-.405-.008.778.778 0 00-.564.264c-.194.21-.74.72-.74 1.756s.757 2.036.863 2.177c.106.14 1.491 2.266 3.613 3.178.505.217.899.347 1.206.444.507.16.968.137 1.332.083.406-.06 1.251-.51 1.428-1 .176-.493.176-.914.123-1.002z",
    fill: "#fff"
  })));
}

export default SvgWhatsappSquare;